function fn_part_form_ride() {
    var $fn = $(".part_form_ride"),
            $lang = $("html").attr("lang");

    if ($fn.length) {
        $fn.find("[data-form-datepicker]").datepicker({
            language: $lang,
            minDate: new Date(),
            autoClose: true,

            onRenderCell: function (date, cellType) {
                var day = date.getDate();
                var month = date.getMonth() + 1;
                var year = date.getFullYear();
                var controlDate = year + '-' + month + '-' + day;

                if (date.getDay() == 0 || date.getDay() == 6) {
                    return {
                        html: '<span style="color:#dedee6;">' + day + '</span>',
                        disabled: true
                    };
                }

                if (fullDays) {
                    if (fullDays.hasOwnProperty(controlDate)) {
                        if (fullDays[controlDate].indexOf('08:00') !== -1 && fullDays[controlDate].indexOf('20:00') !== -1) {
                            return {
                                html: '<span style="color: red;" class="hint--top" aria-label="Obsazeno">' + day + '</span>',
                                disabled: true
                            };
                        } else {
                            return {
                                html: '<span style="color: orange;" class="hint--top" aria-label="Již obsazeno v ' + fullDays[controlDate].join(', ') + '">' + day + '</span>',
                                disabled: false
                            };
                        }
                    }
                }
            },
            onSelect: function (formattedDate, date, inst) {
                inst.$el.trigger("change");
            }
        });

        $fn.find("[data-form-timepicker]").datepicker({
            timepicker: true,
            onlyTimepicker: true,
            minutesStep: 0,
            minMinutes: 0,
            maxMinutes: 0,
            minHours: 8,
            maxHours: 20,
            autoClose: true,
            onSelect: function (formattedDate, date, inst) {
                inst.$el.trigger("change");
            }
        });
    }
}